import { toast } from 'sonner';
import {
  useTaskHoverPreview,
  useUpdateTaskHoverPreview,
} from '../../hooks/queries/useCabinetSettings';
import { cn } from '../../lib/cn';

/** Paramètres › Tâches : la petite carte d'informations qui s'ouvre au survol d'une tâche. */
export function TaskHoverPreviewSection() {
  const enabled = useTaskHoverPreview();
  const update = useUpdateTaskHoverPreview();

  function toggle(checked: boolean) {
    update.mutate(checked, {
      onError: (err) => {
        toast.error(err instanceof Error ? err.message : 'Impossible d’enregistrer l’aperçu au survol');
      },
    });
  }

  return (
    <section className="rounded-cime border border-neutral-200 bg-white p-4 space-y-3">
      <div>
        <h2 className="text-lg font-semibold text-cime-text-primary">Aperçu au survol</h2>
        <p className="text-sm text-cime-text-muted mt-1">
          Une petite carte résume la tâche (description, échéance, personnes) quand on la survole
          dans une liste. Le réglage vaut pour tout le cabinet.
        </p>
      </div>
      <label
        htmlFor="task-hover-preview"
        className={cn(
          'flex items-center gap-3 rounded-md border p-3 cursor-pointer',
          enabled ? 'border-cime-primary bg-cime-primary/5' : 'border-neutral-200',
        )}
      >
        <input
          id="task-hover-preview"
          type="checkbox"
          className="h-4 w-4 accent-cime-primary"
          checked={enabled}
          disabled={update.isPending}
          onChange={(e) => toggle(e.target.checked)}
        />
        <span className="text-sm font-medium text-cime-text-primary">Afficher l’aperçu</span>
      </label>
    </section>
  );
}
